module.exports = __webpack_public_path__ + "img/skill-tools.94380c38.png";